// extracted by mini-css-extract-plugin
export var techMenu = "subMenu-module--techMenu--04a8e";
export var title = "subMenu-module--title--1e0a3";
export var wrapper = "subMenu-module--wrapper--a16ba";